import axios from 'axios'
import { Message } from 'element-ui'
import { baseURL, timeout } from "@/utils/config.js";
import store from "@/store";

const request = axios.create({
    baseURL: baseURL,
    timeout: timeout
})

request.interceptors.request.use(
    config => {
        const token = store.state.auth.token;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + `${token}`
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
request.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob') {
            return response
        }
        return response.data
    },
    error => {
        if (error.response) {
            const data = error.response.data || {};
            const message = extractErrorMessage(data);
            switch (error.response.status) {
                case 401:
                    if (error.config && error.config.url === '/api/login') {
                        return Promise.reject(error)
                    }
                    Message.error('登录已过期，请重新登录')
                    store.dispatch('auth/clearAuth')
                    location.href = "/"
                    break
                case 403:
                    Message.error('没有权限访问')
                    break
                case 404:
                    Message.error('请求的资源不存在')
                    break
                case 500:
                    Message.error('服务器错误')
                    break
                default:
                    Message.error(message)
            }
        } else {
            Message.error('网络错误，请检查您的网络连接')
        }
        return Promise.reject(error)
    }
)

function extractErrorMessage(data) {
    if (!data) return '请求失败';
    if (typeof data === 'string') return data;
    if (Array.isArray(data.error)) return data.error.join('；');
    if (typeof data.error === 'string') return data.error;
    if (Array.isArray(data.errors)) return data.errors.join('；');
    if (typeof data.errors === 'string') return data.errors;
    if (data.detail) return data.detail;
    if (data.message) return data.message;
    if (data.non_field_errors && Array.isArray(data.non_field_errors)) {
        return data.non_field_errors.join('；');
    }
    return '请求失败';
}

export default request